import React from "react";

const Star = () => {
  return (
    <div
      className={` lg:w-10 lg:h-10 w-5 h-5 flex items-center justify-center`}
    >
      <img src="/Images/assets/YellowStar.svg" alt="" />
    </div>
  );
};

export default Star;
